<template>
    <div>
        <transition appear
                    appear-active-class="fade-enter-active"
                    leave-active-class="fade-leave-active">
            <div>
                <p>Le logo de votre Organisme.</p>

                <p>Il sera utilis&eacute; en ent&ecirc;te des formulaires prestataires et pourra &ecirc;tre utilis&eacute; dans la signature de vos e-mails.</p>

                <p>Nous recommandons un format de logo carr&eacute; ou horizontal et de bonne qualit&eacute;. Les formats d&#39;images accept&eacute;s sont <strong>jpg</strong> ou <strong>png</strong>.</p>
            </div>
        </transition>
    </div>
</template>

<script>
    export default {
        name: "LogoField"
    }
</script>
